/**
* @Author: zachalam
* @Date:   2017-04-11T10:31:30-07:00
* @Email:  zach@reflexmedia.com
* @Last modified by:   zachalam
* @Last modified time: 2017-04-11T10:31:30-07:00
*/


import React, { Component } from 'react';
import { Link } from 'react-router';
import Validator from 'validator';
import HeaderOut from '../blocks/HeaderOut';
import Header from '../blocks/Header';
import TextInput from '../common/TextInput';
import Panel from '../common/Panel';
import InputGroup from '../blocks/InputGroup';
import Button from '../blocks/Button';
import Container from '../blocks/Container';
import Headline from '../common/Headline';
import { css, StyleSheet } from 'aphrodite/no-important';
import { box, spacing, link } from '../../style';

const style = StyleSheet.create({
  page: {
    paddingTop: '100px',
    maxWidth: '460px',
    margin: '0 auto'
  }
})

class Restore extends Component {

  constructor(props) {
    //console.log("SUPAPROPS");
    //console.log(props);
    super(props);
    this.state = {
      email: '',
      password: '',
      password_confirmation: '',
      token: props.location.query.token
    }

    this.onChangeHandler = this.onChangeHandler.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  onChangeHandler(e) { this.setState({[e.target.id]: e.target.value}) }


  handleSubmit(e) {
    e.preventDefault();
    // submit form.
    //console.log(this.state);
    this.props.handleSubmit(this.state);

  }

  render() {

    let { errors } = this.props;

    return (
    <Container>
      <div className={css(style.page)}>
        <Headline>Set new password</Headline>
        <Panel>
          <p>Enter your email address and new password below to reset it.</p>
          <form id="restoring" className="form-horizontal" onSubmit={this.handleSubmit}>
              {/* Email */}

              <InputGroup vertical errors={errors.email} inputLabel="Email address">
                <TextInput type="text" error={errors.email} value={this.state.email} id="email" onChange={this.onChangeHandler} />
              </InputGroup>

              <InputGroup vertical errors={errors.password} inputLabel="New Password">
                <TextInput type="password" error={errors.email} value={this.state.password} id="password" onChange={this.onChangeHandler} />
              </InputGroup>

              <InputGroup vertical errors={errors.password_confirmation} inputLabel="Confirm New Password">
                <TextInput type="password" error={errors.password_confirmation} dataError={this.state.passError} value={this.state.password_confirmation} id="password_confirmation" onChange={this.onChangeHandler} />
              </InputGroup>

              <div className="buttonSet">
                <Button type="submit" variant="primary" name="commit">Update Password</Button>
              </div>

          </form>
        </Panel>
      </div>
    </Container>
    );
  }
}

export default Restore;



// WEBPACK FOOTER //
// ./src/components/pages/Restore.jsx